import {
  Step,
  EventingLocation,
  Result,
  Component,
} from '@/components/DynamicFlow/utils/types/types';
import { ContextualDefaults } from '@/types/Mobius';
import { EventContext } from '@/components/DynamicFlow/utils/createEventingPayloadsDE';
import uuid from '@/utils/uuid';

interface ResultsEventContext {
  eventContext: EventContext;
  listId?: string | undefined;
  presets?: ContextualDefaults;
  location?: string;
  productClickedCorrelationId?: string;
  viewCorrelationId?: string;
  brand?: string;
  position?: number;
  capId?: number; // for sku
  programId?: number; // for productId
  outboundUrl?: string;
  isProgramSubmitted?: boolean; // This determines the action outcome
  isUserRequested?: boolean; // for custom dimensions
}

export const formatSubtype = (eventContext: EventContext) => {
  if ((eventContext.currentStep as Step & Result)?.resultType) {
    return `dexp-${(eventContext.currentStep as Step & Result)?.resultType?.replace(/_/g, '-').toLowerCase()}`;
  } else if ((eventContext.currentStep as Step & Component)?.componentType) {
    return `dexp-${(eventContext.currentStep as Step & Component)?.componentType?.replace(/_/g, '-').toLowerCase()}`;
  }
  return 'dexp-results';
};

export const createResultsEventContext = ({
  eventContext,
  listId,
  presets,
  location,
  productClickedCorrelationId,
  viewCorrelationId,
  brand,
  position,
  capId, // for sku
  programId, // for productId
  outboundUrl,
  isProgramSubmitted, // This determines the action outcome
  isUserRequested, // for custom dimensions
}: ResultsEventContext) => {
  // Presets override dcs: when presets are provided, use them for degree/category/subject
  // so createProductClickedPayload (which uses dcs first) gets the right values.
  const dcs =
    presets != null
      ? {
          degree: presets.degree ?? eventContext.dcs?.degree ?? '',
          category: presets.category ?? eventContext.dcs?.category ?? '',
          subject: presets.subject ?? eventContext.dcs?.subject ?? '',
        }
      : eventContext.dcs;

  return {
    ...eventContext,
    dcs,
    formatType: 'dexp-offering',
    formatSubtype: formatSubtype(eventContext),
    formName: 'dexp-hosted-lead-form',
    stepName: 'pii-confirmation',
    location: location || EventingLocation.CONVERSION_DRAWER,
    stepType: 'LEAD',
    listId: listId,
    customDimensions: [
      {
        key: 'sourceCorrelationId',
        value: eventContext.formViewedCorrelationId || '',
      },
      {
        key: 'isUserRequested',
        value: String(isUserRequested),
      },
      {
        key: 'flowId',
        value: eventContext.currentStep?.flowId || '',
      },
    ],
    presets: presets || undefined,
    productClickedCorrelationId: productClickedCorrelationId || uuid(),
    viewCorrelationId,
    brand,
    position,
    sku: capId ? String(capId) : undefined,
    productId: programId ? String(programId) : undefined,
    outboundUrl,
    actionOutcome: isProgramSubmitted ? 'application' : 'explore',
  };
};
